import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <section className="relative overflow-hidden bg-sand-50 section-contrast">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(20,83,45,0.06),_transparent_55%)]" />
      <div className="container mx-auto px-6 py-16 md:py-24 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-3 rounded-full border border-teal-100 bg-white/80 px-4 py-2 text-xs text-teal-700 shadow-sm">
            <span className="h-2 w-2 rounded-full bg-teal-500 animate-pulse" />
            Страница не найдена
          </div>

          <h1 className="mt-6 text-4xl md:text-5xl font-serif text-stone-800">
            404 — такой страницы нет
          </h1>
          <p className="mt-4 text-stone-600 text-lg leading-relaxed">
            Похоже, ссылка неверная или страница была перемещена. Выберите раздел ниже — и вы
            снова на правильном пути.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            <Link to="/">
              <Button className="w-full bg-teal-700 hover:bg-teal-800 text-white py-6 rounded-full text-base font-medium shadow-lg hover:shadow-xl transition-all">
                <Home size={18} className="mr-2" />
                На главную
              </Button>
            </Link>
            <Link to="/appointment">
              <Button
                variant="outline"
                className="w-full border-teal-200 text-teal-700 hover:bg-teal-50 py-6 rounded-full text-base font-medium"
              >
                <Calendar size={18} className="mr-2" />
                Записаться
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-4 text-left">
            <Link
              to="/about"
              className="group rounded-2xl border border-sand-200 bg-white px-5 py-4 text-sm text-stone-600 shadow-sm transition-all hover:-translate-y-0.5 hover:border-teal-200 hover:shadow-md"
            >
              <p className="text-stone-800 font-semibold">Обо мне</p>
              <p className="mt-1 text-stone-500">Опыт, подход и принципы работы.</p>
            </Link>
            <Link
              to="/services"
              className="group rounded-2xl border border-sand-200 bg-white px-5 py-4 text-sm text-stone-600 shadow-sm transition-all hover:-translate-y-0.5 hover:border-teal-200 hover:shadow-md"
            >
              <p className="text-stone-800 font-semibold">Услуги</p>
              <p className="mt-1 text-stone-500">Выберите направление консультации.</p>
            </Link>
            <Link
              to="/appointment"
              className="group rounded-2xl border border-sand-200 bg-white px-5 py-4 text-sm text-stone-600 shadow-sm transition-all hover:-translate-y-0.5 hover:border-teal-200 hover:shadow-md"
            >
              <p className="text-stone-800 font-semibold">Запись</p>
              <p className="mt-1 text-stone-500">Оставьте заявку на консультацию.</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
